import React from 'react';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../constants/ActionTypes';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextAlign,
    availableTextDecoration
} from '../../constants/availableFonts';

const initialState = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextAlign: availableTextAlign,
    availableTextDecoration: availableTextDecoration
};

const formReducer = (state = initialState, action) => {
    return state;
};

export default formReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/form.js